<template>
    <div class="py-4">
        <h4 class="mb-4 text-2xl font-bold">{{ $t('investment_process.please_confirm') }}</h4>
        <p class="mb-4">{{ $t('investment_process.altfg.investment_process_altfg_notice') }}</p>
        <p class="mb-4 font-bold text-gray-700">
            {{ $t('investment_process.altfg.investment_process_altfg_choice_notice') }}
        </p>
        <div class="relative flex items-start pt-2">
            <div class="flex h-6 items-center">
                <input
                    id="altfg_professional_investor"
                    v-model="altfgProfessionalInvestor"
                    aria-describedby="altfg_professional_investor"
                    name="altfg_professional_investor"
                    type="checkbox"
                    class="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary" />
            </div>
            <div class="ml-3 text-sm leading-6">
                <label for="altfg_professional_investor" class="font-semibold text-gray-900">
                    {{ $t('investment_process.altfg.investment_process_altfg_professional_investor') }}
                </label>
            </div>
        </div>
        <BaseHairlineLabel :label="$t('investment_process.or')" />
        <div class="relative flex items-start pt-2">
            <div class="flex h-6 items-center">
                <input
                    id="altfg_legal_entity"
                    v-model="altfgLegalEntity"
                    aria-describedby="investment_process_altfg_legal_entity"
                    name="altfg_legal_entity"
                    type="checkbox"
                    class="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary" />
            </div>
            <div class="ml-3 text-sm leading-6">
                <label for="altfg_legal_entity" class="font-semibold text-gray-900">
                    {{ $t('investment_process.altfg.investment_process_altfg_legal_entity') }}
                </label>
            </div>
        </div>
        <BaseHairlineLabel :label="$t('investment_process.or')" />
        <div class="relative flex items-start pt-2">
            <div class="flex h-6 items-center">
                <input
                    id="altfg_maximum_net_income"
                    v-model="altfgMaximumNetIncome"
                    aria-describedby="investment_process_altfg_maximum_net_income"
                    name="altfg_maximum_net_income"
                    type="checkbox"
                    class="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary" />
            </div>
            <div class="ml-3 text-sm leading-6">
                <label for="altfg_maximum_net_income" class="font-semibold text-gray-900">
                    {{ $t('investment_process.altfg.investment_process_altfg_maximum_net_income') }}
                </label>
            </div>
        </div>
        <BaseHairlineLabel :label="$t('investment_process.or')" />
        <div class="relative flex items-start pt-2">
            <div class="flex h-6 items-center">
                <input
                    id="altfg_maximum_assets"
                    v-model="altfgMaximumAssets"
                    aria-describedby="investment_process_altfg_maximum_assets"
                    name="altfg_maximum_assets"
                    type="checkbox"
                    class="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary" />
            </div>
            <div class="ml-3 text-sm leading-6">
                <label for="altfg_maximum_assets" class="font-semibold text-gray-900">
                    {{ $t('investment_process.altfg.investment_process_altfg_maximum_assets') }}
                </label>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useInvestmentProcessDataState } from '../../../utilities/investment-process/useInvestmentProcess'
import BaseHairlineLabel from '../../base/BaseHairlineLabel.vue'

const { altfgProfessionalInvestor, altfgLegalEntity, altfgMaximumNetIncome, altfgMaximumAssets } = storeToRefs(
    useInvestmentProcessDataState()
)
</script>

<style scoped></style>
